import { render, staticRenderFns } from "./CreateSubAdmin.vue?vue&type=template&id=1785042c&"
import script from "./CreateSubAdmin.vue?vue&type=script&lang=js&"
export * from "./CreateSubAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports